<template>
    <div>
        <span>{{ templateArgs.text }}</span>
        <!--<div class="form-group row">
            <label for="eventName" class="col-sm-3 col-form-label">
                Име на събитие:
            </label>
            <div class="col-sm-9">
                <span class="form-control-plaintext" id="eventName">{{ templateArgs.title}}</span>
            </div>
        </div>

        <div class="form-group row">
            <label for="eventStatus" class="col-sm-3 col-form-label">
                Kапацитет:
            </label>
            <div class="col-sm-9">
                <span class="form-control-plaintext" id="eventStatus">{{ templateArgs.capacity}}</span>
            </div>
        </div>

        <div class="form-group row">
            <label for="eventStart" class="col-sm-3 col-form-label">
                Начало:
            </label>
            <div class="col-sm-9">
                <span class="form-control-plaintext" id="eventStart">{{ toLocalTime(templateArgs.start) }}</span>
            </div>
        </div>

        <div class="form-group row">
            <label for="eventEnd" class="col-sm-3 col-form-label">
                Край:
            </label>
            <div class="col-sm-9">
                <span class="form-control-plaintext" id="eventEnd">{{ toLocalTime(templateArgs.start) }}</span>
            </div>
        </div>-->
    </div>
</template>


<script>
    export default {
        name: 'groupHeaderTemplate',
        data() {
            return {
                templateArgs: {}
            }
        },
        mounted() {
            console.log(this.templateArgs);
        },
        methods: {
        }

    }
</script>

